import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { RequestPayload } from './types';
import { Transaction, TransactionPackage, TransactionPackageDetail } from './models/transaction';
import helpers from './helper';

const ENDPOINT = 'transactions/';

export interface TransactionPayload {
  type_id: number,
  outlet_to_id: number,
  model_id?: number,
  equips?: number[],
  comment: string,
  distributor_id: number
}

export interface TransactionUpdatePayload {
  transaction_id: number
  status_id: number
  document_id?: number
  equip_id?: number
  distributor_id?: number
  comment?: string
}
export interface PackageUpdatePayload {
  package_id: string
  status_id: number
  document_id?: number
  equip_id?: number
  distributor_id?: number
  comment?: string
}

export interface GetPackagePayload {
  transaction_id?: number
  equip_id?: number
  serial_num?: string
  inventory_num?: string
  package_id: string
}

export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getTransactions: (payload: RequestPayload) =>
    instance.post<
      RequestPayload,
      AxiosResponse<ApiResponse<Paginated<'data', Transaction>>>
    >(ENDPOINT + 'list/', payload, config),
  getTransaction: (id: string | number) =>
    instance.get<
      RequestPayload,
      AxiosResponse<ApiResponse<Transaction>>
    >(ENDPOINT + `info/${id}/`, config),
  create: (payload: TransactionPayload) => instance.post<ApiResponse<null>>(ENDPOINT+'create/', payload, config),
  update: (payload: TransactionUpdatePayload) => instance.put<ApiResponse<null>>(ENDPOINT+'update_status/', payload, config),
  updatePackage: (payload: PackageUpdatePayload) => instance.put<ApiResponse<null>>(ENDPOINT+'update_status/package/', payload, config),
  getTransactionPackages: (payload: RequestPayload) =>
    instance.post<
      RequestPayload,
      AxiosResponse<ApiResponse<Paginated<'data', TransactionPackage>>>
    >(ENDPOINT + 'v2/packages/list/', payload, config),
  getTransactionPackage: ({ package_id, ...payload }: GetPackagePayload) => 
    instance.get<
      RequestPayload,
      AxiosResponse<ApiResponse<TransactionPackageDetail>>
    >(ENDPOINT + 'v2/packages/info/' + package_id + '/' + helpers.toQueryString(payload), config),  
});